var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#6371E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4603_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8264 97.336C47.5864 97.336 45.5704 96.952 43.7784 96.184C41.9864 95.384 40.5784 94.264 39.5544 92.824C38.5304 91.384 38.0184 89.704 38.0184 87.784H43.8744C44.0024 89.224 44.5624 90.408 45.5544 91.336C46.5784 92.264 48.0024 92.728 49.8264 92.728C51.7144 92.728 53.1864 92.28 54.2424 91.384C55.2984 90.456 55.8264 89.272 55.8264 87.832C55.8264 86.712 55.4904 85.8 54.8184 85.096C54.1784 84.392 53.3624 83.848 52.3704 83.464C51.4104 83.08 50.0664 82.664 48.3384 82.216C46.1624 81.64 44.3864 81.064 43.0104 80.488C41.6664 79.88 40.5144 78.952 39.5544 77.704C38.5944 76.456 38.1144 74.792 38.1144 72.712C38.1144 70.792 38.5944 69.112 39.5544 67.672C40.5144 66.232 41.8584 65.128 43.5864 64.36C45.3144 63.592 47.3144 63.208 49.5864 63.208C52.8184 63.208 55.4584 64.024 57.5064 65.656C59.5864 67.256 60.7384 69.464 60.9624 72.28H54.9144C54.8184 71.064 54.2424 70.024 53.1864 69.16C52.1304 68.296 50.7384 67.864 49.0104 67.864C47.4424 67.864 46.1624 68.264 45.1704 69.064C44.1784 69.864 43.6824 71.016 43.6824 72.52C43.6824 73.544 43.9864 74.392 44.5944 75.064C45.2344 75.704 46.0344 76.216 46.9944 76.6C47.9544 76.984 49.2664 77.4 50.9304 77.848C53.1384 78.456 54.9304 79.064 56.3064 79.672C57.7144 80.28 58.8984 81.224 59.8584 82.504C60.8504 83.752 61.3464 85.432 61.3464 87.544C61.3464 89.24 60.8824 90.84 59.9544 92.344C59.0584 93.848 57.7304 95.064 55.9704 95.992C54.2424 96.888 52.1944 97.336 49.8264 97.336ZM87.9151 90.184H73.9471L71.5471 97H65.8351L77.7871 63.592H84.1231L96.0751 97H90.3151L87.9151 90.184ZM86.3791 85.72L80.9551 70.216L75.4831 85.72H86.3791ZM122.824 63.64V68.104H113.944V97H108.472V68.104H99.5439V63.64H122.824Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4603_3904",
    x: 34.0186,
    y: 63.207,
    width: 92.8052,
    height: 43.1289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4603_3904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4603_3904",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/SAT.531cd9a912c89374b49fec0c3b7d28fb.svg";
export { ForwardRef as ReactComponent };